import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IAcceptMeetingRequestByTokenPayload extends ISagaCb {
    token: string
    time: string
}

export interface IAcceptMeetingRequestByTokenState {
    status: string
    data: any
    errors: any
}

const initialState: IAcceptMeetingRequestByTokenState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const acceptMeetingRequestByToken = createSlice({
    name: 'meeting-requests/accept-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAcceptMeetingRequestByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const acceptMeetingRequestByTokenActions = acceptMeetingRequestByToken.actions
export default acceptMeetingRequestByToken.reducer
